import React, { Component } from 'react';
import * as PropTypes from 'prop-types';

import Card from '@lwt-helix/card';
import { Col, Row } from '@lwt-helix/layout';
import { Button } from '@lwt-helix/buttons';
import LoadingIcon from '../LoadingIcon/LoadingIcon';
import {
    muted,
    preserveWhitespace,
    cardHeader,
    cardSubheader
} from '../common/styles/Common.css';
import { ButtonTypes } from '../../constants/Enums';

class EditPasswordCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentPassword: '',
            newPassword: '',
            confirmPassword: '',
            wasSubmitted: false,
        };
    }

    render() {
        const { newPassword, confirmPassword, wasSubmitted } = this.state;

        const error = this.props.error &&
            <div className="alert alert-danger" role="alert">
                <strong>Error - </strong>{this.props.error.replace('username or', ('current'))}
            </div>;

        const alert = (newPassword !== confirmPassword) && wasSubmitted &&
            <div className="alert alert-danger" role="alert">
                <strong>Error - </strong> New passwords do not match
            </div>;

        return (
            <>
                {error}
                {alert}
                <Card
                    dataLwtId="edit-password"
                    raised
                    headerProps={{
                        children: <>
                            <div style={cardHeader}>My Settings</div>
                            <div style={cardSubheader}>Password and Security Settings</div>
                        </>
                    }}
                    bodyProps={{
                        children: <>
                            <Row>
                                <Col>
                                    <div className="form-group">
                                        <div style={muted}>Current Password</div>
                                        <input
                                            type="password"
                                            className="form-control null"
                                            autoComplete="off"
                                            value={this.state.currentPassword}
                                            onChange={event => {
                                                this.setState({ currentPassword: event.target.value })
                                            }
                                            }
                                        />
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <div className="form-group">
                                        <div style={muted}>New Password</div>
                                        <input
                                            type="password"
                                            className="form-control null"
                                            autoComplete="off"
                                            value={this.state.newPassword}
                                            onChange={event => {
                                                this.setState({ newPassword: event.target.value })
                                            }
                                            }
                                        />
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col>

                                    <div className="form-group">
                                        <div style={muted}>Confirm Password</div>
                                        <input
                                            type="password"
                                            className="form-control null"
                                            autoComplete="off"
                                            value={this.state.confirmPassword}
                                            onChange={event => {
                                                this.setState({ confirmPassword: event.target.value })
                                            }
                                            }
                                        />
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Button
                                        dataLwtId="save-password"
                                        className="float-right"
                                        onClick={() => {
                                            this.setState({
                                                wasSubmitted: true
                                            });
                                            this.props.handleSaveButtonClick({
                                                userGuid: this.props.user.lwt.uid,
                                                currentPassword: this.state.currentPassword,
                                                newPassword: this.state.newPassword,
                                                confirmPassword: this.state.confirmPassword
                                            });
                                        }}
                                    >
                                        Save
                                    </Button>
                                    <span className="float-right" style={preserveWhitespace}>{'  '}</span>
                                    <Button
                                        dataLwtId="cancel-save-password"
                                        className="float-right"
                                        type={ButtonTypes.SECONDARY}
                                        onClick={() => {
                                            this.props.handleCancelButtonClick()
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                    <LoadingIcon loading={this.props.passwordIsChanging} style={{ float: 'right' }} />
                                </Col>
                            </Row>
                        </>
                    }}
                />
            </>
        );
    }
}

EditPasswordCard.propTypes = {
    error: PropTypes.object,
    user: PropTypes.object,
    handleCancelButtonClick: PropTypes.func,
    handleSaveButtonClick: PropTypes.func,
    passwordIsChanging: PropTypes.bool
};

export default EditPasswordCard;